import React from 'react';
import { SwitchButton } from '@paretogroup/tess';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import { useObmSegmentsTable } from '../obm-segments-table/obm-segments-table.hook';


interface OBMAdvancedSettingsSwitchProps {
    selectedMetrics: Array<string>,
    setSelectedColumns: Function,
}

export const OBMAdvancedSettingsSwitch = ({
    setSelectedColumns,
    selectedMetrics,
}: OBMAdvancedSettingsSwitchProps) => {
    const {
        isSwitchActive,
        setSwitchToggle,
    } = useObmSegmentsTable();
    const {
        paceBudget,
        paceTarget,
        minimumPerformanceValue,
        minimumDailyBudgetValue,
        performanceWindow,
        daysBetweenAdjustmentsBudget,
        daysBetweenAdjustmentsTarget,
    } = CLUSTER_FIELDS_FUNCTIONS;
    const advancedSettingsMetrics = [
        paceBudget.columnName,
        paceTarget.columnName,
        minimumPerformanceValue.columnName,
        minimumDailyBudgetValue.columnName,
        performanceWindow.columnName,
        daysBetweenAdjustmentsBudget.columnName,
        daysBetweenAdjustmentsTarget.columnName,
    ];

    const handleOnChange = () => {
        if (isSwitchActive) {
            setSwitchToggle(!isSwitchActive);

            const removeAdvancedSettingsMetricsFromSelectedMetrics = selectedMetrics.filter(
                metric => !advancedSettingsMetrics.includes(metric),
            );

            return setSelectedColumns(removeAdvancedSettingsMetricsFromSelectedMetrics);
        }

        setSwitchToggle(!isSwitchActive);

        return setSelectedColumns([...selectedMetrics, ...advancedSettingsMetrics]);
    };


    return (
        <SwitchButton
            onChange={() => handleOnChange()}
            checked={isSwitchActive}
        />
    );
};
